import React from 'react'
import '../styles/header.css'

import apigClientFactory from 'aws-api-gateway-client'
import aws from '../aws-config'

export default class Header extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  checkUserAuthentication = (email) => {
    this.setState({
      isLoading: true,
      showLoginFailed: false
    })

    const apigClient = apigClientFactory.newClient({
      invokeUrl: aws.apiGateway.URL,
      region: aws.apiGateway.REGION,
      retryCondition: (err) => {
        return err.response.status === 500
      }
    })

    let headers = {'Access-Control-Allow-Origin': '*'}
    let pathTemplate = '/icare/auth'
    let method = 'GET'
    let params = {
      queryParams: {
        email: email
      }
    }

    apigClient.invokeApi(headers, pathTemplate, method, params)
      .then(result => {
        if (result.data.Item) {
          this.setState({
            isLoading: false,
          })
          this.props.userHasAuthenticated(true, result.data.Item)
        } else {
          this.setState({
            showLoginFailed: true,
            isLoading: false
          })
        }
      })
      .catch(error => {
        console.log('err: ', error)
        this.setState({
          showLoginFailed: true,
          isLoading: false
        })
      })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.checkUserAuthentication(this.state.email);
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  renderHeader = () => {
    return(
      <div>
        <div className="logo">
          <img className="img" src={this.props.logo} alt=""/>
        </div>
        <div className="title">
          <span className="txt">
            {this.props.title}
          </span>
        </div>
        <a href="/" style={{ float: 'right' }}>Logout</a>
      </div>
    )
  }

  renderLoginHeader = () => {
    return (
      <div>
        <div style={{display: "block", width: "50%", height:"100%", float: "left", paddingLeft: "27px", paddingTop: "20px"}}>
          <img src='//d2bsj3sc0hks5v.cloudfront.net/icare/images/LAX-logo.png' alt="" style={{ display: "inline", height: "100%", width: "304px" }}/>
        </div>
        <div className="sign-in">
          <label>
            Registered?
          </label>
          <input type="text"
                 id="email"
                 value={this.state.email}
                 onChange={this.handleChange}
                 placeholder="Enter your Email Address"
                 required
          />
          <button type="button" className="btn btn-primary" onClick={this.handleSubmit}>
            Login
          </button>
        </div>
      </div>
    )
  }

  render() {
    return(
      <div className="header">

        {this.props.isAuthenticated ?
          this.renderHeader() : this.renderLoginHeader()
        }

      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js